import "./styles.scss";

const ChequesPage = () => {
  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>LusidPay Digital Check Printing & eChecks</title>
    <!-- Use Google Fonts for LusidPay-style feel -->
    <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;800&display=swap" rel="stylesheet">
    <style>
      :root {
        --blue-main: #253f83;
        --blue-btn-hover: #0d67e3;
        --blue-dark: #004182;
        --blue-muted: #56687a;
        --blue-light: #dce6f1;
        --grey-main: #38434f;
        --grey-light: #e9e5df;
        --off-white: #fdfaf5;
        --white: #ffffff;
        --accent-green: #00c49a;
      }
      html, body {
        margin: 0;
        padding: 0;
        background: var(--white);
        color: var(--grey-main);
        font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
        // font-size: 18px;
        line-height: 1.6;
      }
      header {
        width: 100%;
        background: var(--white);
        position: sticky;
        top: 0;
        z-index: 100;
        border-bottom: 1px solid var(--grey-light);
      }
      .hero {
        background: var(--white);
        text-align: center;
        padding: 90px 20px 40px 20px;
        margin-bottom: 60px;
      }
      .hero h1 {
        font-size: 2.8rem;
        font-weight: 800;
        color: var(--blue-main);
        margin-bottom: 18px;
        letter-spacing: -1px;
      }
      .hero p {
        font-size: 1.25rem;
        color: var(--grey-main);
        margin-bottom: 0;
        max-width: 650px;
        margin-left: auto;
        margin-right: auto;
      }
      .section {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 1100px;
        margin: 0 auto 100px auto;
        padding: 0 24px;
      }
      .section-title {
        font-size: 2rem;
        font-weight: 700;
        color: var(--blue-main);
        text-align: center;
        margin-bottom: 20px;
        letter-spacing: -0.5px;
      }
        
        h2 {
            margin-top: 40px;
            font-size: 2rem;
        }
        h3 {
            font-size: 1.16rem;
 
            color: #218c45;
        }
        ul {
            padding-left: 22px;
        }
        .features, .workflow {
            display: flex;
            flex-wrap: wrap;
            gap: 28px;
            margin-top: 24px;
        }
        .feature-box, .workflow-step {
            flex-basis: 255px;
            background: #f6f9fc;
            border-radius: 12px;
            padding: 22px;
            box-shadow: 0 2px 12px #19407c08;
            margin-bottom: 12px;
        }
        .workflow-step {
            max-width: 200px;
            padding: 12px;
        }
        .highlight {
            color: #218c45;
            font-weight: bold;
        }
        .cta {
            text-align: center;
            margin: 44px 0 24px 0;
        }
        .cta button {
          background: var(--blue-main);
          color: var(--white);
          border-radius: 24px;
          padding: 14px 38px;
          font-size: 1.1rem;
          font-weight: 700;
          border: none;
          cursor: pointer;
          margin: 0 10px;
          transition: background 0.15s;
          box-shadow: 0 2px 16px rgba(10,102,194,0.06);
        }
        .cta button:hover {
            background: var(--blue-btn-hover);
        }
        .verification {
            // display: flex;
            // flex-direction: column;
            max-width: 1100px;
            margin: 0 auto 60px auto;
            background: #E9F7EF;
            border-left: 8px solid #218c45;
            border-radius: 18px;
            padding: 2px 28px;
            margin-top: 40px;
            margin-bottom: 30px;
        }
        .verification h2 {
            color: #218c45;
            margin: 20px;
            margin-bottom: 10px;
            text-align: center;
            font-size: 1.7rem;
        }
        .verification a {
            display: inline-block;
            color: #fff;
            background: #218c45;
            text-decoration: none;
            padding: 12px 28px;
            border-radius: 7px;
            font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
            font-size: 1rem;
            margin-top: 18px;
            transition: background .20s;
        }
        .verification a:hover {
            background: #19407c;
        }

        .benefits {
            display: flex;
            flex-direction: column;
            align-items: center;
            max-width: 1100px;
            margin: 0 auto 60px auto;
            padding: 32px 28px;
            margin-top: 20px;
            margin-bottom: 30px;
        }

  
      @media (max-width: 1000px) {
        .features-row, .solutions-row { flex-direction: column; align-items: center; }
        .section { padding: 0 8px; }
      }
    </style>
</head>
<body>
    <section class="hero">
      <h1>LusidPay Digital Check Printing & eChecks</h1>
      <p>
        The most flexible, modern way to send check payments—no pre-printed paper needed.
        Print on your own paper, deliver by email or mail, and streamline your workflow in minutes.
      </p>
    </section>

    <section class="section" id="check-payments">
      <div class="section-title">Modernize Your Check Payment Process</div>
      <p style="text-align: center">
        With LusidPay, create and deliver checks for your business instantly. Print checks on <span class="highlight">any standard paper</span>—no special supplies ever required. Email digital checks as PDFs, or print checks to send by post.
      </p>

      <div class="features">
        <div class="feature-box">
          <h3>Send Digital Checks Instantly</h3>
          <p>Send payments in seconds—email a downloadable check PDF to your payee, or print for immediate mailing.</p>
        </div>
        <div class="feature-box">
          <h3>Print Checks on Any Paper</h3>
          <p>Use ordinary printer paper—never buy expensive pre-printed check stock again.</p>
        </div>
        <div class="feature-box">
          <h3>No Recipient Bank Details Needed</h3>
          <p>All that's needed is the recipient's email address. Checks can be deposited at any U.S. bank.</p>
        </div>
      </div>
      <div class="features">
        <div class="feature-box">
          <h3>Deep QuickBooks & Xero Integration</h3>
          <p>Bi-directional sync—no double entry, effortless posting, and all payments fit your accounting workflow.</p>
        </div>
        <div class="feature-box">
          <h3>Manage Cash Flow</h3>
          <p>Send checks only when you're ready. Hold funds until the very last minute with real-time control.</p>
        </div>
        <div class="feature-box">
          <h3>Cut Payables Costs</h3>
          <p>Eliminate buying check stock, envelopes, postage, and manual labor—save time and money instantly.</p>
        </div>
      </div>
    </section>

    <section class="section" id="how-it-works">
      <div class="section-title">How It Works</div>
      <div class="workflow">
        <div class="workflow-step">
            <strong>1. Link Your Accounts</strong>
            <p>Set up LusidPay and securely connect your business bank account.</p>
        </div>
        <div class="workflow-step">
            <strong>2. Create Checks Instantly</strong>
            <p>Enter payment details in LusidPay or import directly from your accounting software. Generate checks in seconds.</p>
        </div>
        <div class="workflow-step">
            <strong>3. Email or Print</strong>
            <p>Send secure PDF checks by email, or print checks yourself to mail by post—your choice every time.</p>
        </div>
        <div class="workflow-step">
            <strong>4. Recipient Deposits Anywhere</strong>
            <p>The recipient prints and deposits the check via ATM, mobile banking, or at any U.S. bank branch.</p>
        </div>
    </div>
    </section>

    <section class="verification">
      <h2>Fast & Secure Check Verification by LusidPay</h2>
      <p>
          LusidPay makes it easy for anyone to verify a check instantly. Our advanced check verification service ensures your check is authentic, confirms payee and amount, and protects against alterations or fraud.
      </p>
      <ul>
          <li>Confirm checks were issued by an authorized party</li>
          <li>Verify payee and critical payment details</li>
          <li>Ensure the check remains unchanged from its original version</li>
      </ul>
      <p>
          Whether you’re a bank, recipient, or business manager, you can quickly verify any LusidPay check online. If any detail is mistyped or altered, the check will not pass verification—keeping your payments protected.
      </p>
  
      <div class="cta">
        <button onclick="window.location='/checks/verify'">Verify a Check Now</button>
      </div>
    </section>

    <section class="benefits">
      <h2>Key Benefits of LusidPay Check Printing</h2>
      <ul>
        <li><strong>No special check stock needed:</strong> Use plain printer paper, any time.</li>
        <li><strong>Multiple delivery options:</strong> Email or mail checks to fit your workflow.</li>
        <li><strong>Accepted everywhere:</strong> Works for all U.S. banks, just like standard checks.</li>
        <li><strong>Audit trail & security:</strong> Each check has a unique history and can be instantly verified.</li>
        <li><strong>Quick setup:</strong> Be up and running in minutes.</li>
        <li><strong>Saves money & time:</strong> Reduce AP costs and manual labor dramatically.</li>
      </ul>
      <div class="cta" style="margin-top: 100px;">
        <button style="white-space: nowrap; min-width: 200px; margin: 0 10px 20px 10px;" onclick="window.location='/contact-us'">Request a Demo</button>
         <p style="margin-top: 10px; color:#19407c;">See how LusidPay can save your business 33–75% on currency conversion and automate your payables.</p>
      </div>
    </section>

</body>
</html>


      `}} />

    </>
  )
}

export default ChequesPage;